export default __webpack_public_path__ + "static/media/safari-pinned-tab.36e4b9f9.svg";